<template>
    <div class="container">
        <div class="common-header-wrap">
            <mt-header class="common-header" title="文章分类">
                <mt-button icon="back" slot="left" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>
        <div class="class-list">
            <div v-for="item in articleclass_list" v-bind:key="item.ac_id" @click="goHomeArticlelist(item.ac_id)">
                <flex-line :is-link="true" :show-border="true">
                    <span>{{item.ac_name}}</span>
                </flex-line>
            </div>
        </div>
        <empty-record v-if="articleclass_list && !articleclass_list.length"></empty-record>
    </div>
</template>

<script>
import { getArticleclassList } from '../../../api/homeArticle'
import EmptyRecord from '../../../components/EmptyRecord'
import { Toast, Indicator } from 'mint-ui'
import flexLine from '../../flexLine'
export default {
  components: {
      flexLine,
    EmptyRecord
  },
  name: 'Articleclass',
  data () {
    return {
      articleclass_list: false
    }
  },
  created: function () {
    this.getArticleclassList()
  },
  methods: {
    getArticleclassList () {
      Indicator.open()
      getArticleclassList().then(res => {
        Indicator.close()
        this.articleclass_list = res.result.article_class
      }).catch(function (error) {
        Indicator.close()
        Toast(error.message)
      })
    },
    goHomeArticlelist (acId) {
      this.$router.push({ name: 'HomeArticlelist', query: { ac_id: acId } })
    }
  }
}
</script>

<style scoped lang="scss">
    .class-list{padding:0 $pageSpace;background: #fff}
</style>
